import { inject } from '@angular/core';
import { type CanActivateFn, PRIMARY_OUTLET, Router, UrlSegment, type UrlTree } from '@angular/router';
import { AccountService } from '@frontendlib/common/services/account.service';
import { MAIN_SPACE_CONTEXT_VARIANT, readSpaceContextSlot } from '@frontendlib/common/utils/space-context-storage';
import { ActiveSpaceContextService } from '@modules/common/services/active-space-context.service';
import { catchError, combineLatest, map, of, take, timeout } from 'rxjs';

export const notesHomeGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  return combineLatest([
    inject(AccountService).getAccount(),
    inject(ActiveSpaceContextService).contextId$(MAIN_SPACE_CONTEXT_VARIANT),
  ]).pipe(
    take(1),
    timeout({ first: 10_000 }),
    map(([account, activeContextId]): boolean | UrlTree => {
      const spaceId =
        activeContextId ?? account.homeSpaceId ?? readSpaceContextSlot(MAIN_SPACE_CONTEXT_VARIANT, account.id);
      if (!spaceId || spaceId === account.id) {
        return true;
      }
      const destination = router.parseUrl(state.url);
      const primary = destination.root.children[PRIMARY_OUTLET];
      primary.segments = [new UrlSegment('spaces', {}), new UrlSegment(spaceId, {}), ...primary.segments];
      return destination;
    }),
    catchError(() => of(router.navigated ? false : router.createUrlTree(['/mail']))),
  );
};
